import NetworkWarning from '@streamlinehq/streamlinehq/img/streamline-light/internet-networks-servers/worldwide-web/network-warning.svg';
import styled from 'styled-components';
import { BouSvgIcon } from '../../../common/generic/components/bou-svg-icon';
import { getBouLinkStyle } from '../../../common/generic/content/texts/bou-link';
import { BouPageWithFrame } from '../../../common/generic/layout/bou-tool-page-with-frame';
import { ErrorWithIcon } from '../../error-view/error-with-icon';

export const IEFallback = () => {
  return (
    <BouPageWithFrame sideBarContent={<></>}>
      <ErrorWithIcon
        title={'Internet Explorer not supported'}
        content={
          <>
            We have followed Microsoft in their{' '}
            <ExternalLink
              href={
                'https://techcommunity.microsoft.com/t5/microsoft-365-blog/microsoft-365-apps-say-farewell-to-internet-explorer-11-and/ba-p/1591666'
              }
              target="_blank"
            >
              decision
            </ExternalLink>{' '}
            to drop support for the deprecated <i>Internet Explorer</i> family of web browsers.
            <br /> <br />
            To use the Upright Model, please upgrade to a modern, supported web browser such as{' '}
            <ExternalLink href={'https://www.microsoft.com/edge'} target="_blank">
              Microsoft Edge
            </ExternalLink>
            ,{' '}
            <ExternalLink href={'https://www.google.com/chrome/'} target="_blank">
              Google Chrome
            </ExternalLink>
            ,{' '}
            <ExternalLink href={'https://www.apple.com/safari/'} target="_blank">
              Apple Safari
            </ExternalLink>
            , or{' '}
            <ExternalLink href={'https://www.mozilla.org/firefox/'} target="_blank">
              Mozilla Firefox
            </ExternalLink>
            .
          </>
        }
        icon={<BouSvgIcon icon={<NetworkWarning />} />}
      />
    </BouPageWithFrame>
  );
};

const ExternalLink = styled.a`
  ${getBouLinkStyle(true)};
`;
